import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import StandaloneRequestDetails from '../common/standalone/standalone-request-details';
import StandaloneOfferForm from '../common/standalone/standalone-offer-form';
import StandaloneAppliedOffers from '../common/standalone/standalone-applied-offers';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import RequestOfferSkeleton from '../common/skeleton/request-offer-skeleton';
import RequestInfo from '../common/request/request-info';
import RequestPreview from '../common/request/request-preview';
import { Panel, PanelHeader, PanelContent } from '../common/panel';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const StandaloneRequest = () => {
    let { id } = useParams();
    const [user] = useState(checkTokenExpirationMiddleware());
    const [reservationRequest, setReservationRequest] = useState(null);
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);
    const [reloadOffers, setReloadOffers] = useState(null);
    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    const handleReloadOffers = () => {
        let reload = { ...reloadOffers };
        setReloadOffers(reload);
    }

    useEffect(() => {
        axios.get(`/api/standalonerequest/${id}`, { headers: headers })
            .then(res => {
                setReservationRequest(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [user])

    return (
        <>
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Categories Offers</PanelHeader>
                        <PanelContent>
                            {
                                loading ?
                                    <RequestDetailsSkeleton />
                                    :
                                    reservationRequest ?
                                        <RequestPreview
                                            label={"Standalone"}
                                            reservationRequest={reservationRequest}
                                            Details={
                                                <StandaloneRequestDetails
                                                    reservationRequest={reservationRequest}
                                                />
                                            }
                                        />
                                        : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>My Standalone Offers</PanelHeader>
                        <PanelContent>
                            {
                                loading ?
                                    <RequestOfferSkeleton />
                                    :
                                    reservationRequest ?
                                        <StandaloneAppliedOffers
                                            reloadOffers={reloadOffers}
                                            reservationReqId={reservationRequest.id}
                                        />
                                        : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Add A Standalone Offer</PanelHeader>
                        <PanelContent>
                            {
                                loading ?
                                    <RequestOfferSkeleton />
                                    :
                                    reservationRequest ?
                                        <StandaloneOfferForm
                                            handleReloadOffers={handleReloadOffers}
                                            reservationRequest={reservationRequest}
                                        />
                                        : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>
                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading ?
                                <RequestInfoSkeleton />
                                :
                                reservationRequest ?
                                    <RequestInfo reservationRequest={reservationRequest} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default StandaloneRequest;